module.exports = __webpack_public_path__ + "static/media/khaleej1.65bf5ee8.png";